export const updateNewFeedback = 'updateNewFeedback';
export const updateIsAddFeedbackClicked = 'updateIsAddFeedbackClicked';
export const updateFeedbacks = "updateFeedbacks";
export const updateIsEditFeedbackClicked = "updateIsEditFeedbackClicked";
export const updateFeedbacksDataTable = "updateFeedbacksDataTable";
export const updateIsViewFeedbackClicked = "updateIsViewFeedbackClicked"